export default "__VITE_ASSET__CclUKhx1__"